import { useState } from 'react';

import { Grid } from '@mui/material';

import { EstadoAutoComplete, PercentualNotaMetaSazonalAutoComplete } from 'components/autocompletes';
import { CissNumberField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function PercentualNotaFiscalGridFilter() {
    const [filterPercentualMotaMetaSazonal, setFilterPercentualMotaMetaSazonal] = useState<FilterValuesProps>({
        property: 'idPercentualNotaRoyaltiesSazonal',
        operator: 'in',
        value: [],
        idProperty: 'idPercentualNotaRoyaltiesSazonal',
    });

    const [filterEstado, setFilterEstado] = useState<FilterValuesProps>({
        property: 'idEstado',
        operator: 'in',
        value: [],
        idProperty: 'idEstado',
    });

    const [filterNotaFiscal, setFilterNotaFiscal] = useState<FilterValuesProps>({
        property: 'peNotaFiscal',
        operator: 'eq',
        value: null,
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterPercentualMotaMetaSazonal, setter: setFilterPercentualMotaMetaSazonal },
                { value: filterEstado, setter: setFilterEstado },
                { value: filterNotaFiscal, setter: setFilterNotaFiscal },
            ]}
        >
            <Grid sx={{ flex: 3 }}>
                <PercentualNotaMetaSazonalAutoComplete
                    multiple={true}
                    value={filterPercentualMotaMetaSazonal.value}
                    onChange={(e, value) => setFilterPercentualMotaMetaSazonal((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid sx={{ flex: 3 }}>
                <EstadoAutoComplete
                    label="UF Destino"
                    multiple={true}
                    value={filterEstado.value}
                    onChange={(e, value) => setFilterEstado((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid sx={{ flex: 3 }}>
                <CissNumberField
                    label="Nota Fiscal %"
                    inputType="decimal"
                    preventEmptyField={false}
                    maxValue={100}
                    forceMaxValue={true}
                    value={filterNotaFiscal.value}
                    onChange={(e) => setFilterNotaFiscal((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
